import { Alert, Slide } from '@mui/material';
import { WifiOff as WifiOffIcon } from '@mui/icons-material';
import { useNetworkStatus } from '../../contexts/NetworkStatusContext';

const OfflineBanner = () => {
  const { isOnline } = useNetworkStatus();

  return (
    <Slide direction="down" in={!isOnline} mountOnEnter unmountOnExit>
      <Alert
        severity="warning"
        icon={<WifiOffIcon />}
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          borderRadius: 0,
          boxShadow: 3,
        }}
      >
        You are offline. Some features are disabled until connection is restored.
      </Alert>
    </Slide>
  );
};

export default OfflineBanner;
